module.exports = __webpack_public_path__ + "img/ic-nnext-active.3e3d3c08.svg";